import React, { useState } from 'react';
import { setFormDetailsQuery, useFormDetailsQuery } from '../../lib/Queries';
import { useParams } from 'react-router-dom';
import Loading from '../../components/Loading';
import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import Question from '../../components/forms/Question';
import FlowBuilder from '../../components/flows/FlowBuilder.jsx';
import EditableQuestion from '../../components/forms/EditableQuestion.jsx';
import Section from '../../components/forms/Section.jsx';
import SectionPicker from '../../components/SectionPicker.jsx';
import Share from '../../components/forms/Share.jsx';
import Design from '../../components/forms/Design.jsx';
import { EyeIcon } from '@heroicons/react/24/outline/index.js';
import EditForm from '../../components/forms/EditForm.jsx';

const FormEditPage = ({ initialTab }) => {
    const { formId } = useParams();

    return <EditForm formId={formId} initialTab={initialTab} />;
};

export default FormEditPage;
